<template>
  <v-dialog v-model="display" @click:outside="closeModal" max-width="490" persistent>
    <v-card>
      <v-card-title class="ConfirmModal-title">{{ title }}</v-card-title>
      <v-card-text>{{ content }}</v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text color="error" @click="closeModal">{{ $t('confirmModal.cancel') }}</v-btn>
        <v-btn text color="success" class="mr-4" @click="confirmModal">{{ $t('confirmModal.confirm') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmModal',

  props: {
    confirm: {
      type: Function,
      default: () => {}
    },
    content: String,
    display: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default() {
        return this.$t('confirmModal.title')
      }
    }
  },

  methods: {
    closeModal() {
      this.$store.commit('CLOSE_CONFIRM_MODAL')
    },
    confirmModal() {
      this.confirm()
      this.closeModal()
    }
  }
}
</script>

<style scoped lang="scss">
.ConfirmModal-title {
  word-break: normal;
}
</style>
